// extracted by mini-css-extract-plugin
export default {"about":"styles_about__IblY3","container":"styles_container__4nhV7"};